import React, { Component } from 'react';

import { EnviarNotif } from "../../funciones/EnviosFunction";
import { toast } from 'react-toastify';

class EnvioInd extends Component {
    state = {
        boton1:{
            icon: "fa fa-send",
            text: "Enviar Notificación",
            disabled: false
        },
    }

    envioInd = () => {
        if (this.state.boton1.disabled === true) return null;
        let { option, asunto, html, aplica } = this.props;

        if (asunto === "") {
            toast.error("El campo Asunto está vacío",{autoClose: 4000});
            return null;
        }

        if (html === "") {
            toast.error("El mensaje está vacío",{autoClose: 4000});
            return null;
        }

        this.setState({
            boton1:{
                icon: "fa fa-spinner fa-spin",
                text: "Enviando",
                disabled: true
            },
        }, () => {
            EnviarNotif (option.id_est.id_est, asunto, html, aplica, (resp) => {
                (resp.status === "Error") ? toast.error(resp.mess,{autoClose: 6000}) : toast.info(resp.mess,{autoClose: 6000});

                this.setState({
                    boton1:{
                        icon: "fa fa-send",
                        text: "Enviar Notificación",
                        disabled: false
                    }
                })
            })
        })
    }

    render() {
        let { n, option } = this.props;
        let { boton1 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (                                                                                                                                                                        
            <tr>
                <td style={styles} align="center"><strong>{n}</strong></td>
                <td style={styles}>
                    {option.est}
                    <div className="text-danger" style={{fontSize: 10}}><strong>Error:</strong> {option.error}</div>
                </td>
                <td style={styles} align="center">
                    <button className="btn btn-primary" onClick={this.envioInd} style={{borderWidth: 1}}><i className={boton1.icon}></i></button>
                </td>
            </tr>
        );
    }
}
 
export default EnvioInd;


// WEBPACK FOOTER //
// ./src/views/Envios/EnvioInd.jsx